"use strict";

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var R = __importStar(require("ramda"));

var error_codes_1 = __importDefault(require("@8base/error-codes"));

exports.isIdTokenExpiredError = R.allPass([R.propEq('code', error_codes_1.default.TokenExpiredErrorCode), R.propEq('message', 'Token expired')]);
exports.hasIdTokenExpiredError = R.any(exports.isIdTokenExpiredError);
exports.hasTokenInvalidError = R.any(R.propEq('code', error_codes_1.default.InvalidTokenErrorCode));
exports.isRefreshTokenExpiredError = R.allPass([R.propEq('code', error_codes_1.default.TokenExpiredErrorCode), R.propEq('message', 'Refresh Token has expired')]);
exports.hasRefreshTokenExpiredError = R.any(exports.isRefreshTokenExpiredError);
exports.hasUserNotFoundError = R.any(R.propEq('code', error_codes_1.default.EntityNotFoundErrorCode));